export const appDataName = "appData";
